export const appDataName = "appData";
